import { render, staticRenderFns } from "./StaffDashboard.vue?vue&type=template&id=25590ea6&scoped=true&"
import script from "./StaffDashboard.vue?vue&type=script&lang=js&"
export * from "./StaffDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StaffDashboard.vue?vue&type=style&index=0&id=25590ea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25590ea6",
  null
  
)

export default component.exports